module.exports = __webpack_public_path__ + "static/media/moneyGray.8ac58063.svg";